import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/flyoutCategories';

export const FLYOUT_CATEGORIES_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const FLYOUT_CATEGORIES_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
